import React from 'react'
import MenuPage from '../../components/Menu/Menu1/Menu'

const EquipmentRental = () => {
  return (
    <div><MenuPage/></div>
  )
}

export default EquipmentRental